/**
 * TestDataBadge Component
 *
 * Visual indicator for test/sample data products.
 * Icon-only square badge following Polaris subdued tone pattern.
 */

import { Icon, Tooltip, Box, Text } from '@shopify/polaris';
import { CodeIcon } from '@shopify/polaris-icons';

export interface TestDataBadgeProps {
  /** Whether to show the tooltip on hover */
  showTooltip?: boolean;
}

/**
 * Test data indicator badge with optional tooltip
 * Displays as a compact square icon that fits alongside status badges
 */
export function TestDataBadge({ showTooltip = true }: TestDataBadgeProps) {
  const badge = (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        borderRadius: '6px',
        backgroundColor: 'var(--p-color-bg-fill-secondary)',
        flexShrink: 0,
      }}
    >
      <Icon source={CodeIcon} tone="subdued" />
    </div>
  );

  if (!showTooltip) {
    return badge;
  }

  return (
    <Tooltip
      content={
        <Box maxWidth="180px">
          <Text as="span" variant="bodySm">
            Generated test data
          </Text>
        </Box>
      }
      preferredPosition="above"
    >
      <span style={{ display: 'inline-flex' }}>{badge}</span>
    </Tooltip>
  );
}
